import React, { useEffect } from "react";
import _ from "lodash";
import { insurers } from "../../services/formServiceFunctions";
import LegalbirdAutoComplete, { LegalbirdAutoCompleteProps } from "../AutoComplete/LegalbirdAutoComplete";
import { AutoCompleteOptionWithId } from "../../types/AutoCompleteOptionWithId";
import { FormChangeEventHandler } from "../../types/UseForm";
import { ValidatorType } from "../../types/ValidatorType";
import validatorStyle from "../Validator/validatorStyle";

type InsurancePickerProps = Omit<
  LegalbirdAutoCompleteProps<AutoCompleteOptionWithId>,
  "value" | "setValue" | "options" | "onChange"
> & {
  name: string;
  value: string | number | null;
  isMandatory?: boolean;
  onChange: FormChangeEventHandler<HTMLInputElement>;
  registerValidators?: Function;
  validators?: Array<ValidatorType>;
  dependentValidationFields?: Array<string>;
};

const InsurancePicker = ({
  name,
  value,
  isMandatory = false,
  disabled = false,
  label = "Versicherungsgesellschaft",
  onChange,
  registerValidators = () => {},
  validators = [],
  dependentValidationFields = [],
  ...rest
}: InsurancePickerProps) => {
  const sortableLabel = (label: string) => {
    let newLabel = label.toLowerCase();
    newLabel = _.replace(newLabel, "ö", "o");
    newLabel = _.replace(newLabel, "ä", "a");
    newLabel = _.replace(newLabel, "ü", "u");
    return newLabel;
  };

  const sortedInsurers: AutoCompleteOptionWithId[] = insurers.sort((a, b) =>
    sortableLabel(a.label).localeCompare(sortableLabel(b.label))
  );

  const selectedInsurer = sortedInsurers.find((insurer) => insurer.id === value) ?? null;

  const handleSetValue = (event: React.SyntheticEvent<Element, Event>, option: AutoCompleteOptionWithId | null) => {
    onChange({
      target: {
        name: name,
        value: option ? option.id : null,
      },
    });
  };

  useEffect(() => {
    if (registerValidators && validators && !disabled) {
      registerValidators(name, validators, dependentValidationFields);
    }
    return () => {
      registerValidators && registerValidators(name, []);
    };
  }, [registerValidators, dependentValidationFields, name, disabled]);

  return (
    <LegalbirdAutoComplete<AutoCompleteOptionWithId>
      label={label}
      disabled={disabled}
      options={sortedInsurers}
      value={selectedInsurer}
      setValue={handleSetValue}
      sx={isMandatory && value === null ? validatorStyle.mandatory : undefined}
      {...rest}
    />
  );
};

export default InsurancePicker;
